<template lang="pug">
div
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    ModalTrocarResponsavel,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_PORTARIA'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showModalVisualizarProcesso: false,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.PORTARIA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_PORTARIA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroResponsavel') },
        { id: 7, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Emitir Portaria', icone: 'fa-file', codigo: 'EMITIR_PORTARIA', ordem: 1, show: this.showEmitirPortaria },
            { id: 3, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showVincularAnalista },
            { id: 4, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_RESPONSAVEL', ordem: 1, show: this.showTrocarResponsavel }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo) !== undefined
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    EMITIR_PORTARIA: async (_this, { item }) => {
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'portaria',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    TROCAR_RESPONSAVEL: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaPortariaListagem.vue